import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, HostBinding, Injector } from '@angular/core';

import { CasinoCoreGamelaunchService, CasinoManager, GameLaunch, GameManagerService } from '@casinocore/platform/core';
import { CloudflareStreamModule } from '@cloudflare/stream-angular';
import { TrackingService } from '@frontend/vanilla/core';
import { PCComponent } from '@frontend/vanilla/features/content';

import { InstagramStoryModalComponent } from '../instagram-story-modal/instagram-story-modal.component';
import { PromoOptinButtonComponent } from '../promo-optin-button/promo-optin-button.component';
import { UserActionService } from '../shared/services/user-action.service';

@Component({
    selector: 'cc-promo-optin-insta-storyitem',
    templateUrl: 'promo-optin-insta-storyitem.component.html',
    standalone: true,
    imports: [NgStyle, NgIf, NgClass, CloudflareStreamModule, PromoOptinButtonComponent],
})
export class PromoOptinInstaStoryitemComponent extends PCComponent {
    promoInstaStoryItem: any;
    optinCta: any;
    optinBtnTxt: string;
    isDisplayCta: boolean;
    isEnableCustomCta: boolean;
    promostoryBgclr: string;
    TitleTxtClr: string;
    SubTitleTxtClr: string;
    DescriptionClr: string;
    TncTxtClr: string;
    TncBgClr: string;
    OptinBtnBgClr: string;
    OptinBtnTxtClr: string;
    TitleFontSize: string;
    SubTitleFontSize: string;
    muteunmuteClr: string;
    ctaText: string;
    mute: boolean = true;
    storyHasVideo: boolean;
    counter: number = 0;
    videoUrl: string;
    cmsVideoUrl: string;
    gameId: string;
    gamingCtaText: string;
    @HostBinding()
    get class() {
        this.promoInstaStoryItem = this.item;
        this.optinBtnTxt = this.promoInstaStoryItem.parameters.OptinBtn;
        this.isDisplayCta = this.promoInstaStoryItem.displayCTA;
        this.isEnableCustomCta = this.promoInstaStoryItem.enableCustomCTA;
        this.promostoryBgclr = this.promoInstaStoryItem.keys.promostoryBgclr;
        this.TitleTxtClr = this.promoInstaStoryItem.keys.TitleTxtClr;
        this.SubTitleTxtClr = this.promoInstaStoryItem.keys.SubTitleTxtClr;
        this.DescriptionClr = this.promoInstaStoryItem.keys.DescriptionClr;
        this.TncTxtClr = this.promoInstaStoryItem.keys.TncTxtClr;
        this.TncBgClr = this.promoInstaStoryItem.keys.TncBgClr;
        this.OptinBtnTxtClr = this.promoInstaStoryItem.keys.OptinBtnTxtClr;
        this.OptinBtnBgClr = this.promoInstaStoryItem.keys.OptinBtnBgClr;
        this.TitleFontSize = this.promoInstaStoryItem.keys.TitleFontSize;
        this.SubTitleFontSize = this.promoInstaStoryItem.keys.SubTitleFontSize;
        this.muteunmuteClr = this.promoInstaStoryItem.keys.muteunmuteClr;
        this.gameId = this.promoInstaStoryItem.gameID;
        this.gamingCtaText = this.promoInstaStoryItem.keys.GamingCtaText;
        if (this.promoInstaStoryItem.customCTA) {
            this.ctaText = this.promoInstaStoryItem.customCTA.text;
            this.optinCta = this.promoInstaStoryItem.customCTA.url;
        }
        if (this.counter == 0 && this.item.videoUrl) {
            this.counter++;
            this.userActionservice.videoPresentStatus(true);
        }
        return this.createClass(this.item.name);
    }

    constructor(
        private tracking: TrackingService,
        private userActionservice: UserActionService,
        private casinoManager: CasinoManager,
        private gameLaunchService: CasinoCoreGamelaunchService,
        public injector: Injector,
        private gameManagerService: GameManagerService,
    ) {
        super();
    }

    ngOnInit() {
        if (this.item?.cmsVideoUrl?.id) {
            this.cmsVideoUrl = this.item.cmsVideoUrl.id;
            this.storyHasVideo = true;
            this.userActionservice.storyHasVideo = true;
        } else if (this.item?.cmsVideoUrl?.src) {
            this.cmsVideoUrl = this.item.cmsVideoUrl.src;
            this.storyHasVideo = true;
            this.userActionservice.storyHasVideo = true;
        } else if (this.item.videoUrl) {
            this.videoUrl = this.item.videoUrl;
            this.storyHasVideo = true;
            this.userActionservice.storyHasVideo = true;
        }
        this.userActionservice.videoMuteObservable.subscribe((isMuted: string) => {
            if (isMuted) {
                if (isMuted == 'muted') {
                    this.mute = true;
                } else {
                    this.mute = false;
                }
            }
        });
    }

    videoLoaded() {
        this.userActionservice.playVideo();
        if (this.userActionservice.storyPaused) {
            this.userActionservice.pauseVideo();
        }
    }

    optinClick() {
        const storyComponent = this.injector.get(InstagramStoryModalComponent);
        const activePromoName = storyComponent.activePromo.promoItemId;
        const activePromoStoryName = storyComponent.activePromo.instaStoryContentModel[storyComponent.activePromoStoryIndex].mainStoryItemName;
        this.tracking.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': 'teaser - embedded video',
            'component.LabelEvent': 'stories',
            'component.ActionEvent': 'click',
            'component.PositionEvent': activePromoName,
            'component.LocationEvent': activePromoStoryName,
            'component.EventDetails': 'custom cta',
            'component.URLClicked': 'not applicable',
        });
    }

    toggleMute($event: any = null) {
        if (this.userActionservice.muteVideo == 'muted') {
            this.userActionservice.muteVideo = 'not_muted';
        } else {
            this.userActionservice.muteVideo = 'muted';
        }
        this.userActionservice.videoMuteBehaviourSubject.next(this.userActionservice.muteVideo);
        $event && $event.stopImmediatePropagation();
    }

    timeUpdate() {
        let counter: number = 0;
        const video = <HTMLVideoElement>document.getElementById('casino-promoinstastory-video');
        if (video) {
            const percentage = (video.currentTime / video.duration) * 100;
            if (percentage == 100) {
                counter++;
            }
            if (counter <= 1) {
                this.userActionservice.videoProgressStatus(percentage);
            }
        }
    }

    cmsTimeUpdate() {
        let counter: number = 0;
        const stream: any = document.querySelector('#casino-promoinstastory-cmsvideo stream');
        if (stream) {
            const percentage = (stream.currentTime / stream.duration) * 100;
            if (percentage == 100) {
                counter++;
            }
            if (counter <= 1) {
                this.userActionservice.videoProgressStatus(percentage);
            }
        }
    }

    launchGame() {
        const gameInfo = this.gameManagerService.getGameInfo(this.gameId);
        const isTouch = this.casinoManager.isTouch();
        if (gameInfo) {
            gameInfo.gameId = this.gameId;
            const gameModel = new GameLaunch();
            gameModel.game = gameInfo;
            gameModel.isTouch = isTouch;
            gameModel.gamePosition = 1;
            gameModel.categoryType = 'GamingStories';
            gameModel.from = 'q';
            gameModel.replaceRouteInHistory = false;
            gameModel.isDemoLaunch = false;
            gameModel.skipUnfinGame = false;
            gameModel.gameLaunchedFrom = 'GamingStories';
            gameModel.gridPosition = 1;
            gameModel.gameContainer = 'GamingStories';
            gameModel.game.lobbyType = '';
            gameModel.clickTimeStamp = this.gameLaunchService.currentTimeStamp();
            this.gameLaunchService.launchGame(gameModel);
        }
    }
}
